/*
  Action Types
 */


export const UPDATE_UI_STATE = 'UPDATE_UI_STATE';

export const UI_STATES = {
  INITIAL: "INITIAL",
  BOOKING_COMPLETED: "BOOKING_COMPLETED",
  SURVEY: "SURVEY"
};

export const GET_CONTACT_INFO_SUCCCESS = 'GET_CONTACT_INFO_SUCCCESS';
export const GET_MERCHANT_INFO_SUCCCESS = 'GET_MERCHANT_INFO_SUCCCESS';
export const GET_FEATURES = 'GET_FEATURES';
export const GET_FEATURES_SUCCESS = 'GET_FEATURES_SUCCESS';
export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const END_AJAX_CALL = 'END_AJAX_CALL';

export const PORTAL_FEATURE = 'portal';
export const ADDRESS_UPDATE_FEATURE = 'addressUpdate';

export const SURVEY_JOB_TYPE = 5;


// WEBPACK FOOTER //
// ./app/core/constants/coreConstants.js